import { useEffect } from 'react';
import PropTypes, { node } from 'prop-types';
import Glide from '@glidejs/glide';

const SpecialCarousel = ({ widget }) => {
  useEffect(() => {
    try {
      const container = widget.querySelector('.glide');
      let glide;
      if (container) {
        glide = new Glide(container, {
          perView: 3,
          gap: 20,
          type: 'carousel',
          breakpoints: {
            800: {
              perView: 2
            },
            480: {
              perView: 2
            }
          }
        });
        glide.mount();
      }

      return () => {
        if (glide) {
          glide.destroy();
        }
      };
    } catch (err) {
      console.log(`Ha ocurrido un error al montar el Special carousel `);
    }
    return () => null;
  }, [widget]);

  return null;
};

SpecialCarousel.propTypes = {
  children: PropTypes.node,
  widget: node.isRequired,
  className: PropTypes.string
};

SpecialCarousel.defaultProps = {
  className: null,
  children: undefined
};

export default SpecialCarousel;
